export default (action, method, values) => {
  const csrfParam = $('meta[name="csrf-param"]').attr('content')
  const csrfToken = $('meta[name="csrf-token"]').attr('content')

  const form = $('<form/>', {
    action: action,
    method: method
  });

  [{ name: csrfParam, value: csrfToken }, ...values].forEach(({ name, value }) => {
    form.append($('<input/>', {
      type: 'hidden',
      name,
      value
    }))
  })
  form.appendTo('body').submit()
}
